<template>
    <div id="app" class="h-100">
        <component :is="layout">
            <router-view />
        </component>
        <app-modals />
    </div>
</template>

<script>
import AppModals from './AppModals'
export default {
    name: 'App',
    components: {
        AppModals,
        Error: () => import('@/layouts/Error.vue'),
        Response: () => import('@/layouts/Response.vue'),
        Session: () => import('@/layouts/Session.vue'),
        System: () => import('@/layouts/System.vue'),
    },
    computed: {
        routeMeta () {
            return (this.$route && this.$route.meta) || { layout: 'System' }
        },
        layout () {
            return this.routeMeta.layout || 'System'
        },
    },
    beforeCreate () {
        this.$startAcl()
    },
}
</script>

<style lang="scss">
html,
body,
#app {
    width: 100%;
    height: 100%;
}
</style>
